/*
 * <track-order-form> — validates order number + email/phone, then redirects to the tracking page
 * built from data-template (e.g. https://www.ninjavan.co/en-my/tracking?id={number}). Placeholders: {number}, {contact}. Contact is only asked for when the template uses it.
 */
class TrackOrderForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.errorEl = this.querySelector('[data-track-error]');
    if (!this.form) return;
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submit();
    });
  }

  showError(message, field) {
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
    this.form.querySelectorAll('input').forEach((input) => input.removeAttribute('aria-invalid'));
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      field.focus();
    }
  }

  submit() {
    const orderInput = this.form.elements.order;
    const contactInput = this.form.elements.contact;
    const number = orderInput.value.replace(/^#/, '').trim();
    const contact = contactInput ? contactInput.value.trim() : '';
    const d = this.dataset;
    const needsContact = Boolean(contactInput) && /\{contact\}/.test(d.template || '');
    if (!number && needsContact && !contact) return this.showError(d.errBoth, orderInput);
    if (!number) return this.showError(d.errOrder, orderInput);
    if (needsContact && !contact) return this.showError(d.errContact, contactInput);

    const template = d.template || '';
    const url = template.replace(/\{number\}/g, encodeURIComponent(number)).replace(/\{contact\}/g, encodeURIComponent(contact));
    if (!/^https?:\/\//i.test(url)) return this.showError(d.errConfig, null);
    this.errorEl.hidden = true;
    window.location.assign(url);
  }
}

if (!customElements.get('track-order-form')) customElements.define('track-order-form', TrackOrderForm);
